import React from "react";
import { Box } from "@chakra-ui/react";
import EditLessonStructure from "./components/EditLessonStructure";
import AdminNavbar from "../../../../components/navbars/adminNavbar/adminNavbar";
import EditLessonNominee from "./components/EditLessonNominee";

const HomeContentPanel = () =>{
    return(
        <Box>
            <AdminNavbar />
            <EditLessonStructure />
            <EditLessonNominee />
        </Box>
    )
}

export default HomeContentPanel;